// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__W0t4U","loading":"Loading_loading__6jiNW"};